import BasePlugin from "../base/BasePlugin";

import AdtStore from "data/AdtStore";

function dateFormat(dt) {
    return ArmusScript["dateFormat(Date,String)"](dt, "MM/dd/yy");
}

function patientLabelHunks(pat) {
    const mrn = pat.get("medrecn");
    const first = pat.get("stspatfname");
    const last = pat.get("stspatlname");
    const dob = dateFormat(pat.get("stsdob"));
    return [
        `MRN: ${mrn}`,
        `Name: ${first} ${last}, DOB: ${dob}`,
    ];
}

export default class AdtPlugin extends BasePlugin {

    initialize(options) {
        super.initialize(options);

        this.set("fluxContext", "CTX_MappingPlugin_ADT");
        this.set("name", "ADT");
        this.set("id", "adt");
        this.set("fields", [
            { key: "mrn", type: "string", name: "MRN" },
            { key: "admitdate", type: "date", name: "Admit Date" },
            { key: "firstname", type: "string", name: "First Name" },
            { key: "lastname", type: "string", name: "Last Name" },
            { key: "dob", type: "date", name: "Date of Birth" },
        ]);
    }

    hasPaginationParams() {
        return true;
    }

    getPagination(query) {
        return AdtStore.getPagination(query);
    }

    getQueryLO(query, initiate, interactive) {
        return initiate
            ? AdtStore.getHotLO(query, interactive)
            : AdtStore.getColdLO(query);
    }

    getLabelForResult(ep) {
        let hunks;
        if (ep.entityKey === "adt/1-0/patient") {
            hunks = patientLabelHunks(ep);
        } else if (ep.entityKey === "adt/1-0/episode") {
            hunks = patientLabelHunks(ep.get("patient"));
            const admit = dateFormat(ep.get("stsadmitdt"));
            const disch = dateFormat(ep.get("stsdischdt"));
            hunks.splice(1, 0, `Admission: ${admit} - ${disch}`);
        } else {
            return super.getLabelForResult(ep);
        }
        return hunks.join(", ");
    }

    getButtonListingPrefix() {
        return "Map From ADT Record ";
    }
}



// WEBPACK FOOTER //
// ./app/lib/mapping/sources/adt/AdtPlugin.js